import Spinner from 'react-bootstrap/Spinner';

  

const Loader=(startLoader)=>
{


return(
    <>
    
    <div>


    <h1>Din ansökan sparas vänligen vänta</h1>
    <Spinner animation="border" role="status" >
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  
          
          </div>
          
    </>

        )
}
        export default Loader;

        //https://www.npmjs.com/package/react-spinners